import React, { useContext, useEffect, useState } from 'react';
import { Drawer, Button, Card } from 'antd';
import { withRouter } from 'react-router-dom';
import {
  deleteActivityFromSequence,
} from '../utils/arrayOperations';
import Activity from './Activity';
import ChatBot from '../pages/Chatbot';
import { StoreContext } from '../containers/Store';
import * as ROUTES from '../constants/routes';
import * as ROLES from '../constants/roles';
import activities from '../data/activities';


const ActivityDrawer = ({
  history
}) => {
  let {
    user: {
      user
    },
    sequence: {
      sequence: seq,
      storeSequence,
    },
    tracking: {
      activityId: actId,
      storeActivityId,
      answers: ans,
      storeAnswers
    },
    drawer: {
      titleRightDrawer,
      visibleRightDrawer,
      setRightDrawer,
      stepId,
      reference
    }
  } = useContext(StoreContext);

  let { sequence } = seq;
  if (!sequence) sequence = []; 
  let { activityId } = actId;
  if (!activityId) activityId = 0;
  let { answers } = ans;
  if (!answers) answers = [];

  const [refActivity, refPath] = reference;
  const activitySequence = sequence.filter(seq => seq.activity === stepId);

  useEffect(() => {
    if (!!user && history.location.state) {
      storeActivityId({ activityId: history.location.state+1, token: user.token });
    }
  }, [history.location.state]);

  const [activityWidth, setActivityWidth] = useState(Math.floor(window.innerWidth*0.45));

  useEffect(() => {
    setActivityWidth(Math.floor(window.innerWidth*0.4));
  }, [window.innerWidth])

  const extractInspirations = (activityId, pathId) => {
    if (!!activities) {
      if (activities.filter(act =>
        act.activity === activityId &&
        act.path === pathId).length > 0) {
        return activities.filter(act =>
          act.activity === activityId &&
          act.path === pathId)[0].inspirations;
      } else {
        return ""
      }
    } else {
      return ""
    }
  }

  const extractSources = (activityId, pathId) => {
    if (!!activities) {
      if (activities.filter(act =>
        act.activity === activityId &&
        act.path === pathId).length > 0) {
        return activities.filter(act =>
          act.activity === activityId &&
          act.path === pathId)[0].sources;
      } else {
        return ""
      }
    } else {
      return ""
    }
  }

  return (
    <Drawer
      title={titleRightDrawer}
      placement="right"
      width={window.innerWidth < 520 ? window.innerWidth-50: Math.floor(window.innerWidth / 2)}
      closable={false}
      onClose={() => setRightDrawer(false)}
      visible={visibleRightDrawer}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        { !!user &&
          user.roles.includes(ROLES.STUDENT_DEMO) &&
          activitySequence.length > 0 &&
          activityId > stepId && 
          <Activity activityWidth={activityWidth} activityHeight="0.9" localActivityId={stepId} />}
        { !!user &&
          user.roles.includes(ROLES.STUDENT_DEMO) &&
          activitySequence.length > 0 &&
          activityId === stepId && 
          <Button
            type="primary"
            onClick={() => {
              setRightDrawer(false);
              window.location.replace(ROUTES.CHATBOT);
            }}
          >
            Continuer
          </Button> 
        }       
        { !!user &&
          user.roles.includes(ROLES.STUDENT_DEMO) &&
          activitySequence.length === 0 &&
          activityId === stepId &&
          <Button
            type="primary"
            onClick={() => {
              setRightDrawer(false);
              window.location.replace(ROUTES.CHATBOT);
            }}
          > Commencer l'activité </Button>
        }
        { !!user &&
          user.roles.includes(ROLES.STUDENT_DEMO) &&
          activitySequence.length === 0 &&
          activityId < stepId &&
          <div> Terminer les autres activités pour débloquer le contenu </div>
        }
        { !!user &&
          user.roles.includes(ROLES.STUDENT_DEMO) &&
          activitySequence.length > 0 &&
          activityId > stepId && 
          stepId > 0 &&
          <Button
            style={{ maxWidth: '300px', margin: 'auto', marginTop: '16px'}}
            type="primary"
            onClick={() => {
              storeActivityId({ activityId: stepId, token: user.token });
              sequence[sequence.length-1].type = "answer";
              storeSequence({ sequence: [...sequence], token: user.token });
              const answer = sequence[sequence.length-1];
              answer.tms = Date.now();
              storeAnswers({
                answers: [...answers, answer],
                token: user.token
              });  
              setRightDrawer(false);
              window.location.replace(ROUTES.CHATBOT);
            }}
          >
            Reprendre
          </Button> 
        }

        {/* Teacher logic */}
        { !!user &&
          user.roles.includes(ROLES.TEACHER_DEMO) &&
          <div>
            {!!extractInspirations(refActivity, refPath) && 
              <div>
                <h4> Références </h4>
                <p> {extractInspirations(refActivity, refPath)} </p>
                <p> <em> {extractSources(refActivity, refPath)} </em></p>
              </div>
            }
            <ChatBot />
          </div>
        }
      </div>
    </Drawer>
  )
};

export default withRouter(ActivityDrawer);
